// extracted by mini-css-extract-plugin
export default {"container":"Mail_container__LKdi7","containerInner":"Mail_containerInner__PgBtv","padBottom":"Mail_padBottom__jTvQW","textArea":"Mail_textArea__gaVCQ","dark":"Mail_dark__3c+Sa"};